import React, { Component } from 'react';

import { Container, Typography, Box, Tooltip } from '@mui/material';
import moment from 'moment';
import { withSnackbar } from 'notistack';
import { withTranslation } from 'react-i18next';
import ReactPlaceholder from 'react-placeholder';
import { connect } from 'react-redux';
import 'react-placeholder/lib/reactPlaceholder.css';
import { Breadcrumbs } from 'wae_rwlb_reactlibrary';

import { getQuotationTableData, selectQuotation, getAllQuotationsData } from '../../../actions';
import { Table } from '../../../components';
import { breadcrumbNameMap } from '../../../helpers/config';
import { formatAmount, formatedText } from '../../../helpers/functions';
import i18n from '../../../helpers/i18nMain';
import QuotationPlaceholder from '../QuotationPlaceholder';
import { styles } from './styles';

const columnsConfig = t => [
  {
    field: 'col1',
    headerName: t('quotationScreenTranslations:SALES_QUOTATION'),
    key: 'SalesQuotation',
    // minWidth: 150,
    // flex: 1,
    inputType: 'TextField',
  },
  {
    field: 'col2',
    headerName: 'SuperSeeded Part No',
    key: 'ConcatSuperMaterials',
    minWidth: 150,
    // flex: 1,
    inputType: 'TextField',
    hideFromHeader: true,
    hideFromFilter: true,
  },
  {
    field: 'col3',
    headerName: 'Quotation Type',
    key: 'SalesQuotationType',
    // minWidth: 150,
    // flex: 1,
    inputType: 'TextField',
  },
  {
    field: 'col4',
    headerName: 'Sold To Party',
    key: 'SoldToParty',
    minWidth: 150,
    flex: 1,
    inputType: 'TextField',
    renderCell: params2 => {
      const text = `${formatedText(params2.getValue(params2.id, 'col11'))}(${params2.value})`;
      return (
        <Tooltip title={`${params2.getValue(params2.id, 'col11')}(${params2.value})`}>
          <Typography nowrap={false}>{params2.row.col11 !== '' ? text : '-'}</Typography>
        </Tooltip>
      );
    },
  },
  {
    field: 'col8',
    headerName: 'Quotation Valid To',
    key: 'QuotationValidTo',
    minWidth: 150,
    // flex: 1,
    inputType: 'Date',
    valueFormatter: params => {
      return params.value !== null ? moment(params.value).format('MMMM DD, YYYY') : '-';
    },
  },
  {
    field: 'col9',
    headerName: 'Gross Amount',
    key: 'GrossAmount',
    minWidth: 150,
    // flex: 1,
    inputType: 'Float',
    renderCell: params2 => {
      return formatAmount('en-AE', params2.value, params2.getValue(params2.id, 'col5'));
    },
  },
  {
    field: 'col10',
    headerName: 'Discount Price',
    key: 'DiscountAmount',
    minWidth: 150,
    // flex: 1,
    inputType: 'Float',
    renderCell: params2 => {
      return formatAmount('en-AE', params2.value, params2.getValue(params2.id, 'col5'));
    },
  },
  {
    field: 'col12',
    headerName: 'Tax',
    key: 'TotalTaxAmount',
    minWidth: 150,
    flex: 1,
    inputType: 'Float',
    renderCell: params2 => {
      return formatAmount('en-AE', params2.value, params2.getValue(params2.id, 'col5'));
    },
  },
  {
    field: 'col7',
    headerName: 'Net Value',
    key: 'TotalNetValue',
    minWidth: 150,
    flex: 1,
    inputType: 'TextField',
    renderCell: params2 => {
      return formatAmount('en-AE', params2.value, params2.getValue(params2.id, 'col5'));
    },
  },
  {
    field: 'col6',
    headerName: 'Overall Status',
    key: 'ProcessStatusText',
    // minWidth: 150,
    // flex: 1,
    inputType: 'TextField',
  },

  {
    field: 'col5',
    headerName: t('quotationScreenTranslations:CURR'),
    key: 'TransactionCurrency',
    minWidth: 150,
    // flex: 1,
    hideFromHeader: true,
    hideFromFilter: true,
    inputType: 'TextField',
  },
  {
    field: 'col11',
    headerName: 'Sold To Party Name',
    key: 'SoldToPartyName',
    minWidth: 150,
    // flex: 1,
    hideFromHeader: true,
    hideFromFilter: true,
    inputType: 'TextField',
  },
  {
    field: 'col13',
    headerName: 'Customer Reference',
    key: 'CustomerReference',
    minWidth: 150,
    // flex: 1,
    // hideFromHeader: true,
    // hideFromFilter: true,
    inputType: 'TextField',
  },
];

class Quotation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 0,
      rowsPerPage: 20,
      filteredData: [],
      searchTerm: '',
      filterField: '',
      showPriceFilter: false,
      isLoading: false,
    };
  }

  async componentDidMount() {
    try {
      const { page, rowsPerPage } = this.state;
      const skip = page;
      const top = rowsPerPage;
      await this.props.getQuotationTableData(skip, top, this.props.enqueueSnackbar);
    } catch (err) {
      console.log(err);
    }
  }

  handleChange = async (e, value) => {
    try {
      const { rowsPerPage, searchTerm, showDateFilter, filterField, showPriceFilter } = this.state;
      const { t } = this.props;
      const skip = value * rowsPerPage;
      this.setState({ page: value });
      const columnsConfigData = columnsConfig(t);
      const selectedCol = columnsConfigData.find(c => c.field === filterField);
      let filterStr = '';
      if (searchTerm !== '' && selectedCol !== undefined) {
        filterStr =
          showDateFilter || showPriceFilter
            ? `${selectedCol.key} eq ${searchTerm}`
            : `${selectedCol.key} eq '${searchTerm}' or substringof('${searchTerm}', ${selectedCol.key}) eq true`;
      }
      if (filterStr !== '') {
        await this.props.getQuotationTableData(
          skip,
          rowsPerPage,
          this.props.enqueueSnackbar,
          filterStr
        );
      } else {
        await this.props.getQuotationTableData(skip, rowsPerPage, this.props.enqueueSnackbar);
      }
      window.scrollTo(0, 0);
    } catch (err) {
      console.log(err);
    }
  };

  saveFilterData = async (fData, selectedCol, searchTerm = '') => {
    const { rowsPerPage, showDateFilter, showPriceFilter } = this.state;
    let filterStr = '';
    if (searchTerm !== '') {
      filterStr =
        showDateFilter || showPriceFilter
          ? `${selectedCol.key} eq ${searchTerm}`
          : `${selectedCol.key} eq '${searchTerm}' or substringof('${searchTerm}', ${selectedCol.key}) eq true`;
    }
    if (filterStr !== '') {
      this.props.getQuotationTableData(0, rowsPerPage, this.props.enqueueSnackbar, filterStr);
      this.setState({ page: 0 });
    }
    this.setState({ filteredData: fData });
  };

  loadQuotationsData = async () => {
    this.setState({ isLoading: true });
    await this.props.getAllQuotationsData(0, this.props.enqueueSnackbar);
    this.setState({ isLoading: false });
  };

  clearFilter = () => {
    const { rowsPerPage } = this.state;
    this.props.getQuotationTableData(0, rowsPerPage, this.props.enqueueSnackbar);
    this.setState({
      searchTerm: '',
      filterField: '',
      selectedDate: null,
      showDateFilter: false,
      page: 0,
    });
  };

  saveFilterFields = data => {
    this.setState(prevState => ({
      ...prevState,
      ...data,
    }));
  };

  renderQuotations = () => {
    const { quotations, t } = this.props;
    const {
      rowsPerPage,
      filteredData,
      filterField,
      searchTerm,
      showDateFilter,
      selectedDate,
      isLoading,
    } = this.state;
    const { quotationDataArr, listCount, failText } = quotations;
    if (quotationDataArr) {
      return (
        <Table
          onRowClick={item => {
            this.props.selectQuotation(item.row);
            this.props.history.push(`/quotations/${item.row.col1}`);
          }}
          columnsConfig={columnsConfig(t)}
          data={quotationDataArr}
          showExport
          language={i18n.language}
          rowsPerPage={rowsPerPage}
          listCount={listCount}
          page={this.state.page}
          onPageChange={this.handleChange}
          saveFilterData={this.saveFilterData}
          filteredData={filteredData}
          loadFullData={this.loadQuotationsData}
          filterField={filterField}
          searchTerm={searchTerm}
          saveFilterFields={this.saveFilterFields}
          clearFilter={this.clearFilter}
          selectedDate={selectedDate}
          showDateFilter={showDateFilter}
          t={t}
          isLoading={isLoading}
        />
      );
    }
    if (failText !== '') {
      return (
        <Typography sx={styles.failText} textAlign="center">
          {failText}
        </Typography>
      );
    }
    return (
      <Typography sx={styles.failText}>
        {t('quotationScreenTranslations:NO_QUOTATION_FOUND')}
      </Typography>
    );
  };

  render() {
    const { quotations, t } = this.props;
    const { isLoading } = quotations;
    return (
      <Container>
        <Breadcrumbs {...this.props} breadcrumbNameMap={breadcrumbNameMap(t)} />
        <ReactPlaceholder
          showLoadingAnimation
          ready={!isLoading}
          customPlaceholder={<QuotationPlaceholder />}
        >
          <Box sx={styles.tableContainer}>{this.renderQuotations()}</Box>
        </ReactPlaceholder>
      </Container>
    );
  }
}

const mapStateToProps = state => {
  return {
    quotations: state.quotations,
  };
};
const cQuotation = connect(mapStateToProps, {
  getQuotationTableData,
  getAllQuotationsData,
  selectQuotation,
})(Quotation);
const tQuotation = withTranslation(['quotationScreenTranslations'])(cQuotation);
const sQuotation = withSnackbar(tQuotation);

export { sQuotation as Quotation };
